<template>
  <v-carousel
    hide-delimiters
    :interval="nInterval"
    v-model="value"
    :autoplay="true"
    height="90vh"
    cycle
    v-if="items && items.length"
  >
    <v-carousel-item v-for="(item, i) in items" :key="i">
      <v-card class="pa-0">
        <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
          <v-spacer />
          <span class="text-semibold subtitulo">
            {{ item.titulo | fUpperCase }}
          </span>
        </v-toolbar>
        <v-card-text class="pa-1 ma-0">
          <a
            :href="item.link"
            v-if="item.link != '' && item.link != null"
            target="_blank"
          >
            <v-img :src="item.path" :alt="item.titulo" cover />
          </a>
          <v-img :src="item.path" :alt="item.titulo"  cover  v-else />
        </v-card-text>
      </v-card>
    </v-carousel-item>
  </v-carousel>
</template>
<script>
import axiosServices from "@/services/axiosServices.js";
export default {
  props: {
    nIdModulo: {
      type: Number,
    },
  },
  data() {
    return {
      items: [],
      value: 0,
      oRutaImagnes: {},
      nInterval: 6000,
    };
  },
  mounted() {
    this.onGetItems();
  },
  filters: {
    fUpperCase(value) {
      if (!value) return "";
      // console.warn(`The value passed to the 'uppercase' filter must be a string. Received ${typeof value}.`);
      if (typeof value !== "string") return value;

      return value.toUpperCase();
    },
  },
  watch: {
    value() {
      // Si items es vacio entonces por defecto asignamos 6 segundos de transición
      let nInterval = 6000;
      if (this.items.length == 0) return nInterval;
      // de lo contrario traemos el tiempo del slider actual y le multiplicamos 1000 para pasarlo a milisegundos
      setTimeout(() => {
        this.nInterval = this.items[this.value].tiempo * 1000;
      }, 1000);
    },
  },
  methods: {
    async onGetItems() {
      const { aData } = await axiosServices.getConfiguration(
        "/sac/sliders",
        true,
        ""
      );
      this.items = aData;
    },
  },
};
</script>